import { motion } from "framer-motion";

// Gary's handwritten light-gold signature that "draws itself" into place.
export const SignatureReveal = () => {
  const dur = 2.2;
  return (
    <div className="mb-3" data-testid="founder-signature">
      <motion.div
        className="inline-block overflow-hidden whitespace-nowrap align-bottom"
        initial={{ maxWidth: 0 }}
        whileInView={{ maxWidth: 760 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: dur, ease: [0.4, 0, 0.2, 1] }}
      >
        <span
          className="font-signature text-[3.375rem] sm:text-[4.05rem] leading-[1.4] pt-1 pr-3 select-none inline-block"
          style={{ color: "#EDD9A3", textShadow: "0 0 22px rgba(231,204,134,0.35)" }}
        >
          Gary Malkin
        </span>
      </motion.div>
      <svg viewBox="0 0 320 24" className="w-56 sm:w-64 h-6 mt-1 overflow-visible" aria-hidden="true">
        <motion.path
          d="M4 14 C 60 2, 120 2, 175 12 C 210 18, 250 20, 300 8 C 306 6, 312 8, 314 12"
          fill="none" stroke="#D9BE78" strokeWidth="2" strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 1.3, delay: dur * 0.5, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};
